import React from "react";
import NavigationSidebar from "../NavigationSidebar";
import TweetList from "../TweetList";
import PostSummaryList from "../PostSummaryList";
import EditProfiles from "./EditProfiles";

const EditProfileScreenA9 = () => {
  return(
    <div className="container bg-black text-white">
      <div className="row mt-2 gx-0">
        <div className="col-sm-2 col-md-2 col-lg-1 col-xl-2 col-xxl-2">
          <NavigationSidebar active={"profile"}/>
        </div >
        <div className="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6">
          <EditProfiles/>
          <TweetList/>
        </div>
        <div className="col-sm-0 col-md-0 col-lg-4 col-xl-4 col-xxl-4 d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block">
          <PostSummaryList title={"What's happening"}/>
        </div>
      </div>
    </div>
  );
};

export default EditProfileScreenA9;
